module.exports = __webpack_public_path__ + "static/illustration@2x-206cbc7bac1171dbbfa52cebf56ed519.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/illustration@2x.png
// module id = 2720
// module chunks = 168707334958949